module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAeCAYAAACiyHcXAAAAAXNSR0IArs4c6QAAAU9JREFUSA3tVTuqhEAQbEUFNfIURoIH0Ctq5AW8h5GBqaKJoScwU/CD+6ph4IW7PQtuYMM4Isx0dXV1aUzTdNHNYSF/EAS3wZjnmczbsv9L/IBQZDxMfI0J27YJSyd4RKUXXNdFfd/z8TAMyTAM0VViTaB6AMiyjPI8p2EYxIyImUDVy7LQtm1c/bquYiYM2LbEMQECAOq65uRJkpDjOIQWfRJwTDEIJAIQz/M4J1j5FAAOAoS4HbjgOA5mAu9xHJNpyiQmO/WXFMJs25aKouDVdZ1YmGIQqP5boaWJ8zwJDCCk7dDWhGVZlKYpg5AKE4fFwlQjWlWV1ohqgYAwm6ahsiyZCd/3CV6hzIs/vvkQMwFPgEfAoMCK67oinwBOLWECyDiOXK/0B6YtTDAQRRGD2Pedd8lD3A6VTCe5uuMnzOoB8bRDMaB2ng7M6p3xAsWiiRmXGp8aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chrome-menu.png
// module id = 246
// module chunks = 0